import { atom } from 'jotai';
import { ClickPositionPrefix } from '~/utils/click-position';

export const $CurrentPositionPrefix = atom<ClickPositionPrefix>(ClickPositionPrefix.none);
